import { render, staticRenderFns } from "./treatment-container.vue?vue&type=template&id=58888a64&scoped=true&lang=pug"
import script from "./treatment-container.js?vue&type=script&lang=js&external"
export * from "./treatment-container.js?vue&type=script&lang=js&external"
import style0 from "./treatment-container.vue?vue&type=style&index=0&id=58888a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58888a64",
  null
  
)

export default component.exports